import {FormattedMessage} from 'react-intl'
import {AsideMenuItem} from '../AsideMenuItem'
import {useMenuPermission} from '../../../../helpers/hooks/menuHook'

const ListsMenu = () => {
  const {filterMenuItems, isMenuItemAllowed} = useMenuPermission()

  return (
    <>
      {isMenuItemAllowed('GENERAL.ASIDE_MENU.CONTENT_SECTION') && (
        <>
          <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
              <span className='menu-section text-gray-300 fw-bold text-uppercase fs-8 ls-1'>
                <FormattedMessage id='GENERAL.ASIDE_MENU.CONTENT_SECTION' />{' '}
              </span>
            </div>
          </div>

          {filterMenuItems(menuItems).map((item, index) => (
            <AsideMenuItem
              key={index}
              to={item.to}
              title={item.title}
              fontIcon={item.fontIcon}
              icon={item.icon}
            />
          ))}
        </>
      )}
    </>
  )
}

const menuItems = [
  {
    to: '/lists/categories/list',
    title: 'GENERAL.ASIDE_MENU.CONTENT_CATEGORIES_TITLE',
    fontIcon: 'bi-archive',
    icon: '/media/icons/duotune/ecommerce/ecm009.svg',
  },
  {
    to: '/lists/statuses/list',
    title: 'GENERAL.ASIDE_MENU.CONTENT_STATUSES_TITLE',
    fontIcon: 'bi-archive',
    icon: '/media/icons/duotune/abstract/abs037.svg',
  },
]

export default ListsMenu
